// extracted by mini-css-extract-plugin
export default {"Label":"Checkbox_Label__5nx5L","Disabled":"Checkbox_Disabled__yAkYu","Big":"Checkbox_Big__8BBNu","Checkmark":"Checkbox_Checkmark__nlYfC"};